import * as types from "../actions/types/passwordReset.types";

const initialState = {
    initiatePasswordResetState: "",
    initiatePasswordResetLoader: false,
    validatePasswordResetState: "",
    validatePasswordResetLoader: false,
    validatePasswordWithOtpState: "",
    validatePasswordWithOtpLoader: false,
};

export const passwordResetReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.INITIATE_PASSWORD_RESET_SUCCEEDED:
            return {
                ...state,
                initiatePasswordResetState: "success",
                initiatePasswordResetLoader: false
            };
        case types.INITIATE_PASSWORD_RESET_FAILED:
            return {
                ...state,
                initiatePasswordResetState: "failed",
            };
        case types.INITIATE_PASSWORD_RESET_DEFAULT:
            return {
                ...state,
                initiatePasswordResetState: "",
            };
        case types.INITIATE_PASSWORD_RESET_STARTED:
            return {
                ...state,
                initiatePasswordResetLoader: true
            };
        case types.VALIDATE_PASSWORD_RESET_STARTED:
            return {
                ...state,
                validatePasswordResetLoader: true
            };
        case types.VALIDATE_PASSWORD_RESET_SUCCEEDED:
            return {
                ...state,
                validatePasswordResetState: "success",
                validatePasswordResetLoader: false
            };
        case types.VALIDATE_PASSWORD_RESET_FAILED:
            return {
                ...state,
                validatePasswordResetState: "failed",
                validatePasswordResetLoader: false
            };
        case types.VALIDATE_PASSWORD_RESET_DEFAULT:
            return {
                ...state,
                validatePasswordResetState: ""
            };
        case types.VALIDATE_PASSWORD_WITH_OTP_STARTED:
            return {
                ...state,
                validatePasswordWithOtpLoader: true
            };
        case types.VALIDATE_PASSWORD_WITH_OTP_SUCCEEDED:
            return {
                ...state,
                validatePasswordWithOtpState: "success",
                validatePasswordWithOtpLoader: false
            };
        case types.VALIDATE_PASSWORD_WITH_OTP_FAILED:
            return {
                ...state,
                validatePasswordWithOtpState: "failed",
                validatePasswordWithOtpLoader: false
            };
        case types.VALIDATE_PASSWORD_WITH_OTP_DEFAULT:
            return {
                ...state,
                validatePasswordWithOtpState: ""
            };
        default:
            return state;
    }
};
